// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any, showMapview?: boolean) => ({
  mainContiner: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2, 2),
    cursor: 'pointer',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
    boxShadow: '2px 6px 8px 0px #0000001A',
    '& .MuiFab-root': {
      display: 'none',
    },
    '&:hover': {
      '& .MuiFab-root': {
        display: 'flex',
      },
    },
    '& .MuiFab-root.showFab': {
      display: 'flex',
    },
    ...(showMapview && {
      margin: theme.spacing(1, 0),
    }),
    position: 'relative',
  },
  deleteBackdrop: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(255,255,255,0.7)',
    backdropFilter: 'blur(20px)',
    zIndex: 100,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '1rem',
  },
  deleteDialogBox: {
    minWidth: 320,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  deleteDialogText: {
    color: theme.palette.text.primary,
    textAlign: 'center',
    textTransform: 'none',
    fontSize: '1rem',
  },
  deleteDialogActions: {
    display: 'flex',
    gap: theme.spacing(1),
    marginRight: theme.spacing(2),
  },
  deleteCancelBtn: {
    minWidth: 100,
  },
  deleteConfirmBtn: {
    minWidth: 100,
  },
  folderItemContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  folderIconContainer: {
    marginRight: theme.spacing(1),
    color: '#1C364B',
    borderRadius: '50%',
    backgroundColor: '#E5EAEE',
    width: '50px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  folderName: {
    fontWeight: 500,
    fontSize: '1rem',
  },
  projectCount: {
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
  },
  folderDetails: {
    marginLeft: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
  },
  moreIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '32px !important',
    width: '36px !important',
    borderRadius: '50%',
    padding: theme.spacing(1, 2),
    backgroundColor: '#F0F0F5',
    boxShadow: 'none',
    zIndex: 100,
  },
  menuList: {
    minWidth: '150px',
  },
  fontWeight: {
    fontWeight: 300,
  },
  folderListItemPopper: {
    zIndex: 9999,
    left: '-5rem !important',
    '& .MuiPaper-root': {
      borderTopRightRadius: '20px',
      boxShadow: '0px 2px 12px 0px rgba(0,0,0,0.1)',
      '& .MuiButtonBase-root.MuiMenuItem-root:hover': {
        color: theme.palette.primary.main,
        fontWeight: 400,
      },
    },
  },
  buttonProgress: {
    color: '#777777',
  },
  folderNameText: {
    textAlign: 'start',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '233px',
    width: '100%',
    display: 'block',
  },
  activeDroppableHover: {
    border: `1px solid ${theme.palette.primary.main}`,
  },
});

export default styles;
